export const getCountryId = (countryCode: string | undefined) => {
  switch (countryCode?.toLowerCase()) {
    case "sk":
      return 1;
    case "en":
      return 2;
    default:
      return 0;
  }
};

export const getCountryCodeFromHostname = (
  hostname: string,
  fallbackCountryCode: string = "cz"
) => {
  const normalizedHostname = hostname.trim().toLowerCase().replace(/\.$/, "");
  const firstDomainLabel = normalizedHostname.split(".")[0];
  const topLevelDomain = normalizedHostname.split(".").pop();

  if (
    normalizedHostname.endsWith(".automotive.ald.socgen") &&
    firstDomainLabel.startsWith("sk-servisy-")
  ) {
    return "sk";
  }

  if (
    normalizedHostname.endsWith(".automotive.ald.socgen") &&
    firstDomainLabel.startsWith("cz-servisy-")
  ) {
    return "cz";
  }

  if (topLevelDomain === "sk" || topLevelDomain === "cz") {
    return topLevelDomain;
  }

  return fallbackCountryCode.toLowerCase();
};

export const getCountryShortcut = (countryId: number | undefined) => {
  switch (countryId) {
    case 1:
      return "sk";
    case 2:
      return "en";
    default:
      return "cs";
  }
};
